import { render, staticRenderFns } from "./RegistrationFooter.vue?vue&type=template&id=5d4f7e53&scoped=true&"
var script = {}
import style0 from "./RegistrationFooter.vue?vue&type=style&index=0&id=5d4f7e53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4f7e53",
  null
  
)

export default component.exports